import * as React from "react";
import classNames from "classnames";

interface Props {
    className?: string,
}
export default class LoginModal extends React.Component<Props> {
    constructor(props: Readonly<Props>) {
        super(props);
    }
    componentDidMount(){
    }

    render() {
        let modalClasses = classNames(
            "df-modal",
            "df-login-modal",
            this.props.className);
        return (<>
                <div className={"df-login-backdrop"} />
                <div className={modalClasses}>
                    {this.props.children}
                </div>
            </>
        )
    }
}

interface HeaderProps {
    title: string;
}

export class LoginModalHeader extends React.Component<HeaderProps> {
    constructor(props: Readonly<HeaderProps>) {
        super(props);
    }
    render(){
        return(
            <header className={"login-header df-modal-header"}>
                <h1>{this.props.title}</h1>
                <div className= {"login-logo df-login-logo"} />
            </header>
        )
    }
}
export class LoginModalContent extends React.Component {
    render(){
        return(
            <div className={"df-modal-content"}>
                {this.props.children}
            </div>
        )
    }
}